import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { UsuariosService } from '@features/seguridad/usuarios/services/usuarios.service';
import { LOG } from '../err/Logger';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: any;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private dialog: MatDialog,
        private _seguridad: UsuariosService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.user = JSON.parse(localStorage.getItem('user'));
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }




    cambiarPassword() {
        Swal.fire({
            title: "Cambiar mi contraseña",
            html:`
                    <div class="flex flex-col items-center">
                        <div class="flex items-center justify-between">
                            <img src="assets/images/logo/logo.svg" alt="Logo" class="my-4 w-16"> 
                            <span class="mx-2 font-bold text-2xl">INPRO sistema</span>
                        </div>
                        <input type="password" id="password1" class="swal2-input mt-2" placeholder="Nueva contraseña">
                        <input type="password" id="password2" class="swal2-input mt-2" placeholder="Confirmar nueva contraseña">
                    </div>
            
            `,
            showCancelButton: true,
            confirmButtonText: "Cambiar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: 'bg-blue-500 text-white hover:bg-blue-600',
                cancelButton: 'bg-gray-500 text-white hover:bg-gray-600',
            },
            preConfirm: () => {
                const password1 = (document.getElementById("password1") as HTMLInputElement).value;
                const password2 = (document.getElementById("password2") as HTMLInputElement).value;
    
                if (password1 !== password2) {
                    Swal.showValidationMessage('Las contraseñas no coinciden');
                }
    
                return { password: password1 };
            },
        })
        .then((result) => {
            if (result.isConfirmed) {
                const newPassword = result.value.password;
    
                this._seguridad.cambiarMiPassword({ password: newPassword })
                    .subscribe(
                        {
                            next: (response: any) => {
                                if (response) {
                                    Swal.fire('Contraseña', 'Contraseña Actualizada', 'success')
                                }
                            },
                            error: (response) => {
                                LOG('Error al cambiar contraseña', response)
                            }
                        }
                    )
            }
        });
    }
    




}


